// extracted by mini-css-extract-plugin
export var text = "quote-module--text--Nkza-";